// Registration

<template>
  <div
    class="reg-container justify-center pt-4 pb-5"
    v-if="!sym.userInfo.userId"
  >
    <component :is="'script'" src="https://www.google.com/recaptcha/api.js" />

    <form
      id="lms1000"
      class="reg-form lams-light border-main curved-1 shadow-dark"
      @submit.prevent
    >
      <Ul class="crumbs text-charcoal mb-3">
        <!-- <li><sym-link to="/">Home</sym-link></li>
      <li><span aria-current="page">Registration</span></li> -->
      </Ul>

      <div class="d-flex justify-between text-charcoal">
        <span class="display-7 bold mb-3">{{ formTitle }}</span>
      </div>

      <div class="mb-3">
        <p class="info text-center p-1 mb-1 curved">Login Credentials</p>
        <sym-text
          plain
          align="bottom"
          class="mb-3"
          v-model="logonId"
          caption="Login ID *"
          @changing="onLogonIdChanging"
        ></sym-text>

        <div id="app mt-2">
          <p class="">Minimum Password Requirements</p>
          <ul>
            <li v-bind:class="{ is_valid: contains_eight_characters }">
              8 Characters
            </li>
            <li v-bind:class="{ is_valid: contains_number }">
              Contains Number
            </li>
            <li v-bind:class="{ is_valid: contains_uppercase }">
              Contains Uppercase
            </li>
            <li v-bind:class="{ is_valid: contains_special_character }">
              Contains Special Character
            </li>
          </ul>

          <div
            class="checkmark_container"
            v-bind:class="{ show_checkmark: valid_password }"
          >
            <svg width="50%" height="50%" viewBox="0 0 140 100">
              <path
                class="checkmark"
                v-bind:class="{ checked: valid_password }"
                d="M10,50 l25,40 l95,-70"
              />
            </svg>
          </div>

          <input
            :type="showPassword ? 'text' : 'password'"
            @input="checkPassword"
            v-model="password"
            autocomplete="off"
            placeholder="Password"
            class="ShowPassword"
          />
          <!-- <span class="showEyeIcon"
            ><i class="fa fa-eye " @click="togglePasswordVisibility"></i
          ></span> -->
          <span class="showEyeIcon">
            <i
              v-if="showPassword"
              @click="togglePasswordVisibility"
              class="fa fa-eye"
            ></i>

            <i
              v-else
              @click="togglePasswordVisibility"
              class="fa fa-eye-slash"
            ></i>
          </span>

          <!-- <sym-button
            class="show-password text-info -mt-1 sm-1"
            plain
            caption="Show Password"
            :captionWidth="32"
            @click="togglePasswordVisibility"
          ></sym-button> -->

          <!-- <sym-text
            plain
            align="bottom"
            @input="checkPassword"
            v-model="password"
            caption="Password"
            type="password"
          ></sym-text> -->
        </div>

        <div class=" color-grey">
          <sym-text
            plain
            align="bottom"
            v-model="confirmPassword"
            caption="Confirm Password *"
            :type="showCorrectPassword ? 'text' : 'password'"
            @changing="onConfirmPasswordChanging"
            class="ConfirmPassword"
          ></sym-text>
          <!-- <input
            :type="showCorrectPassword ? 'text' : 'password'"
            @input="onConfirmPasswordChanging"
            v-model="confirmPassword"
            autocomplete="off"
            placeholder="Confirm Password"
            class="ShowPassword"
          /> -->

          <span class="ShowConfirmEyeIcon">
            <i
              v-if="showCorrectPassword"
              @click="toggleCorrectPasswordVisibility"
              class="fa fa-eye"
            ></i>

            <i
              v-else
              @click="toggleCorrectPasswordVisibility"
              class="fa fa-eye-slash"
            ></i>
          </span>
          <!-- <span class="ShowConfirmEyeIcon"
            ><i class="fa fa-eye " @click="toggleCorrectPasswordVisibility"></i>
          </span> -->
          <!-- <button
            class="show-password text-info -mt-1 sm-1"
            plain
            caption="Show Password"
            :captionWidth="32"
            :inputLeft="true"
            @click="togglePasswordVisibility"
          ></button> -->
        </div>

        <p class="info text-center p-1 mb-1 curved mt-4">Personal Info</p>
        <sym-text
          plain
          align="bottom"
          v-model="lastName"
          caption="Last Name *"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="firstName"
          caption="First Name *"
        ></sym-text>
        <sym-text
          plain
          align="bottom"
          v-model="middleName"
          caption="Middle Name"
        ></sym-text>

        <div class="equal-width">
          <!-- <sym-text
            plain
            align="bottom"
            v-model="shortName"
            caption="Short Name *"
          ></sym-text> -->
          <sym-date
            plain
            align="bottom"
            v-model="birthDate"
            caption="Birth Date *"
            @changing="onBirthDateChanging"
            @blur="onBirthDateChanging"
          ></sym-date>

          <p v-if="isUnderAge">Sorry, you must be 18 or older to register.</p>
          <p v-if="registrationSuccess">Registration successful!</p>
        </div>

        <sym-memo
          plain
          align="bottom"
          v-model="address"
          caption="Address *"
        ></sym-memo>

        <sym-text
          plain
          align="bottom"
          v-model="email"
          caption="Email Address"
          @changing="onEmailChanging"
        ></sym-text>

        <!-- <div class="equal-width mt-2" v-if="isEmailVerificationVisible"> 
        <input type="tel" ref="OTP" v-model="emailOTP" placeholder="(OTP) 0000">
        <button type="button" class="warning w-50 text-center shadow" :disabled="isEmailDisabled" @click="onResendConfirmation()">Request OTP  ({{ emailCountDown }})</button>
      </div> -->

        <div class="equal-width">
          <!-- <sym-text
            plain
            align="bottom"
            v-model="phoneNumber"
            caption="Mobile Number *"
            @changing="onPhoneNumberChange"
            @input="validatePhoneNumber"
            placeholder="09*********"
            type="tel"
            :style="{
              borderColor: isValidPhoneNumber ? 'green' : 'grey',
            }"
          ></sym-text> -->
          <div class="PhoneContainer">
            <span class="PhoneHeader">Mobile Number *</span>
            <input
              class="MobilePhone"
              v-model="phoneNumber"
              @input="validatePhoneNumber"
              placeholder="09*********"
              type="tel"
              :style="{
                borderColor:
                  isValidPhoneNumber == 'valid'
                    ? 'green'
                    : isValidPhoneNumber == 'invalid'
                    ? 'red'
                    : '',
              }"
            />
          </div>

          <!-- <div v-if="result !== null">
            <p>{{ result }}</p>
          </div> -->
          <!-- <sym-text
            plain
            align="bottom"
            v-model="OTP"
            caption="OTP *"
            cue="(OTP) 0000"
            type="tel"
          ></sym-text> -->
        </div>

        <div class="equal-width mt-2 mb-2">
          <input
            type="tel"
            ref="OTP"
            v-model="OTP"
            @changing="stopCountDown()"
            placeholder="(OTP) 0000"
          />

          <button
            type="button"
            class="warning w-50 text-center shadow"
            :disabled="isDisabled"
            @click="onResendOTP()"
          >
            Request OTP ({{ countDown }})
          </button>
          <!-- <button
            type="button"
            class="warning w-50 text-center shadow"
            :disabled="isDisabled"
            @click="onResendOTP()"
          >
            Request OTP
          </button> -->
        </div>

        <div v-if="isEngineer">
          <p class="info text-center p-1 mb-1 curved mt-4">License</p>
          <sym-text
            plain
            align="bottom"
            v-model="prcNumber"
            caption="PRC License Number *"
          ></sym-text>

          <div class="equal-width">
            <sym-date
              plain
              align="bottom"
              v-model="prcIssueDate"
              caption="Date Issued *"
            ></sym-date>
            <sym-date
              plain
              align="bottom"
              v-model="prcExpiryDate"
              caption="Expiry *"
            ></sym-date>
          </div>

          <sym-combo
            plain
            vertical
            align="bottom"
            v-model="surveyorTypeId"
            caption="Type of Practice"
            display-field="surveyorTypeName"
            :datasource="surveyorType"
          ></sym-combo>

          <div class="mt-4" v-if="surveyorTypeId == 1 || surveyorTypeId == 3">
            <p class="info text-center p-1 mb-1 curved mt-4">Tax Receipt</p>
            <sym-text
              plain
              align="bottom"
              v-model="ptrNumber"
              caption="Receipt Number *"
            ></sym-text>

            <div class="equal-width">
              <sym-date
                plain
                align="bottom"
                v-model="ptrIssueDate"
                caption="Date Issued *"
              ></sym-date>
              <sym-date
                plain
                align="bottom"
                v-model="ptrExpiryDate"
                caption="Expiry *"
              ></sym-date>
            </div>
          </div>

          <!--         
        <p class="info text-center p-1 mb-1 curved mt-4">Tax Receipt</p>
        <sym-text plain align="bottom" v-model="ptrNumber" caption="Receipt Number *"></sym-text>

        <div class="equal-width">
          <sym-date plain align="bottom" v-model="ptrIssueDate" caption="Date Issued *"></sym-date>
          <sym-date plain align="bottom" v-model="ptrExpiryDate" caption="Expiry *"></sym-date>
        </div>
       -->
        </div>

        <!-- <sym-check v-model="acceptTerms" class="text-info ml-0 mt-3" plain caption="I have read the Privacy Policy" :captionWidth="62" :inputLeft="true"></sym-check> -->

        <a
          href="./res/pla/Policy.pdf"
          class="mt-2"
          target="_blank"
          @click="termsToggle = true"
          >View Privacy Policy</a
        >

        <!-- <div class="recaptcha-container mt-2">
          <div
            class="g-recaptcha d-inline-block curved"
            :data-sitekey="recaptcha.siteKey"
            data-callback="recaptchaCallback"
            data-expired-callback="recaptchaExpiredCallback"
          ></div>
        </div> -->
        <!-- <button type="button" class="reg-button warning w-100 text-center shadow lg-3 p-1 mt-3 mb-0" :disabled="!canRegister" @click="onSubmit">Register &raquo;</button> -->
        <button
          type="button"
          class="reg-button warning w-100 text-center shadow lg-3 p-1 mt-3 mb-0"
          @click="onSubmit"
        >
          Register &raquo;
        </button>
        <button
          type="button"
          class="primary text-center w-100 lg-1 shadow mt-3 mb-2"
          @click="goBack()"
        >
          <i class="fa fa-arrow-left mr-2"></i> Back
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { verifyRecaptcha } from "../../js/dbSys";

import { get, ajax } from "../../js/http";

import { DateTime } from "../../js/core";

import { appConfig } from "../../js/session";

import PageBase from "../PageBase.vue";

const countDownSeconds = 150;
const emailCountDownSeconds = 150;
// const buttonEnabledSeconds = 5;

export default {
  extends: PageBase,
  name: "lms1000",

  data() {
    return {
      accountId: -1,
      lastName: "",
      firstName: "",
      middleName: "",
      shortName: "",
      logonId: "",
      password: "",
      confirmPassword: "",
      birthDate: null,
      isUnderAge: false,
      registrationSuccess: false,
      email: "",
      phoneNumber: "",
      address: "",
      accountTypeId: 4,
      errorMessage: "",
      prcNumber: "",
      prcIssueDate: null,
      prcExpiryDate: null,
      result: null,
      ptrNumber: "",
      ptrIssueDate: null,
      ptrExpiryDate: null,

      recaptcha: {
        siteKey: "",
        isHuman: false,
      },
      surveyorType: [],
      surveyorTypeId: 0,

      acceptTerms: false,
      termsToggle: false,
      OTP: "",
      requestedOTP: "",
      countDown: countDownSeconds,
      emailCountDown: emailCountDownSeconds,
      buttonEnabled: false,
      emailButtonEnabled: false,
      isEmailVerificationVisible: false,
      emailVerificationCode: "",
      emailOTP: "",
      requestedEmailOTP: "",

      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password: false,
      isPTRRequiredFlag: 0,
      showPassword: false,
      showCorrectPassword: false,
    };
  },

  computed: {
    formTitle() {
      return this.accountTypeId === 3
        ? "Geodetic Engineer Sign-Up"
        : "Client Registration";
    },

    isEngineer() {
      return this.accountTypeId === 3;
    },

    canRegister() {
      return this.recaptcha.isHuman;
      // return this.recaptcha.isHuman && this.acceptTerms;
    },

    isDisabled() {
      return this.isValidPhoneNumber != "valid" || this.buttonEnabled;
      // return this.countDown > buttonEnabledSeconds;
    },

    isEmailDisabled() {
      return !this.email || this.emailButtonEnabled;
      // return this.countDown > buttonEnabledSeconds;
    },
    isValidPhoneNumber() {
      let value = "";
      if (this.phoneNumber.length == 0) {
        value = "default";
        return value;
      }

      const phoneNumberRegex = /^09\d{09}$/;
      const isValid = phoneNumberRegex.test(this.phoneNumber);

      value = isValid ? "valid" : "invalid";
      return value;
    },
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleCorrectPasswordVisibility() {
      this.showCorrectPassword = !this.showCorrectPassword;
    },

    getTargetPath() {
      const me = this,
        q = {};

      if (me.accountTypeId) {
        q.acctTypeId = me.accountTypeId;
      }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;
      let typeId = 0;

      if ("acctTypeId" in q && me.core.isInteger(q.acctTypeId)) {
        typeId = parseInt(q.acctTypeId);
        if (typeId > 2 && typeId < 5) {
          me.accountTypeId = typeId;
        }
      }
    },

    checkPassword() {
      this.password_length = this.password.length;
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);
      this.contains_special_character = format.test(this.password);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },

    // API calls

    createAccount() {
      const me = this;

      let payload = {
        accountId: -1,
        lastName: me.lastName,
        firstName: me.firstName,
        middleName: me.middleName,
        shortName: me.shortName,
        logonId: me.logonId,
        password: me.password,
        birthDate: me.birthDate,
        email: me.email.toLowerCase(),
        phoneNumber: me.phoneNumber,
        validPhoneNumber: me.phoneNumber,
        address: me.address,
        accountTypeId: me.accountTypeId,
        prcNumber: me.prcNumber,
        prcIssueDate: me.prcIssueDate,
        prcExpiryDate: me.prcExpiryDate,
        ptrNumber: me.ptrNumber,
        ptrIssueDate: me.ptrIssueDate,
        ptrExpiryDate: me.ptrExpiryDate,
        surveyorTypeId: me.surveyorTypeId,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      // return ajax('api/accounts?origin=' + window.location.origin, options);

      // pass empty origin if email is empty so verification email is not sent
      // const origin = !me.email ? '' : window.location.origin;
      const origin = "";
      return ajax("api/accounts?origin=" + origin, options);
    },

    startCountDown() {
      const me = this;

      me.intervalId = setInterval(me.countDownHandler, 1000);
    },

    emailStartCountDown() {
      const me = this;

      me.emailIntervalId = setInterval(me.emailCountDownHandler, 1000);
    },

    // emailStopCountDown () {
    //   const me = this;

    //   if (me.emailIntervalId) {
    //     emailClearInterval(me.emailIntervalId);
    //   }

    //   me.emailIntervalId = 0;
    // },

    stopCountDown() {
      const me = this;

      if (me.intervalId) {
        clearInterval(me.intervalId);
      }

      me.intervalId = 0;
    },

    emailCountDownHandler() {
      const me = this;

      if (me.emailCountDown === 0) {
        me.emailCountDown = emailCountDownSeconds;
        me.emailButtonEnabled = false;
        me.emailStopCountDown();
        return;
      }

      me.emailCountDown -= 1;
    },

    countDownHandler() {
      const me = this;

      if (me.countDown === 0) {
        me.countDown = countDownSeconds;
        me.buttonEnabled = false;
        me.stopCountDown();
        return;
      }

      me.countDown -= 1;
    },

    onResendOTP() {
      const me = this;

      let wait = me.wait();

      me.InsertSMS().then(
        (result) => {
          me.stopWait(wait);
          if (result) {
            me.dialog.success("OTP message sent to your phonenumber.");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    InsertSMS() {
      const me = this,
        phoneNumber = "+63" + me.phoneNumber.substring(1, 11),
        // phoneNumber = me.phoneNumber,
        requestedOTP = Math.floor(1000 + Math.random() * 9000),
        message = "Your One-Time Password (OTP) is " + requestedOTP;

      me.requestedOTP = requestedOTP;
      me.buttonEnabled = true;

      if (!me.intervalId) {
        me.startCountDown();
      }

      let payload = {
        message: message,
        phoneNumber: phoneNumber,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax("api/sms-notification", options);
    },

    sendConfirmation() {
      const me = this,
        toEmail = me.email,
        accountName = me.lastName,
        verifyUrl =
          window.location.origin +
          "/verifier?email=" +
          me.email +
          "&code=" +
          me.accountCode;

      let payload = {
        accountName: accountName,
        toEmail: toEmail,
        verifyUrl: verifyUrl,
      };

      const body = JSON.stringify(payload),
        options = me.core.getAjaxOptions("POST", body);

      return ajax("api/mails/confirmation", options);
    },

    // event handlers

    onLogonIdChanging(e) {
      // https://stackoverflow.com/questions/17616624/detect-if-string-contains-any-spaces
      if (/\s/.test(e.proposedValue)) {
        e.message = "Login ID cannot contain spaces / special characters.";
        e.preventDefault();
        return;
      }

      if (e.proposedValue.toString().length < 6) {
        e.message = "Login ID must be at least 6 characters.";
        e.preventDefault();
        return;
      }

      e.callback = this.logonIdCallback;
    },

    logonIdCallback(e) {
      e.message =
        "Login ID '<b>" + e.proposedValue + "</b>' is already registered.";

      return this.isValidEntity(
        "dbo.WebAccount",
        "logonId",
        e.proposedValue,
        false
      ).then((result) => {
        return !result;
      });
    },

    onConfirmPasswordChanging(e) {
      if (e.proposedValue.toString() !== this.password) {
        e.message = "Password mismatch.";
        // e.preventDefault();
        return;
      }
    },

    onBirthDateChanging(e) {
      if (e.proposedValue instanceof DateTime) {
        let p = e.proposedValue,
          today = DateTime.now();

        if (p.year < 1930) {
          e.preventDefault();
          return;
        }

        if (p > today) {
          e.preventDefault();
          return;
        }
      }
    },

    onEmailChanging(e) {
      if (!e.proposedValue) {
        return;
      }

      if (!this.core.isValidEmail(e.proposedValue)) {
        e.message = "(" + e.proposedValue + ") is not a valid email address.";
        e.preventDefault();
        return;
      }

      // this.isEmailVerificationVisible = true;
      e.callback = this.emailCallback;
    },

    emailCallback(e) {
      e.message =
        "Email '<b>" + e.proposedValue + "</b>' is already registered.";

      return this.isValidEntity(
        "dbo.WebAccount",
        "email",
        e.proposedValue,
        false
      ).then((result) => {
        return !result;
      });
    },

    // onPhoneNumberChange(e) {
    //   e.callback = this.phoneNumberCallBack;
    // },
    validatePhoneNumber() {
      if (!this.phoneNumber) {
        this.result = null;
        return;
      }

      if (this.phoneNumber.length > 11) {
        this.phoneNumber = this.phoneNumber.slice(0, 11);
        // e.callback = this.phoneNumberCallBack;
      }

      // Check if the phone number is valid based on the regular expression
      // if (this.isValidPhoneNumber) {
      //   this.result = "";
      // } else {
      //   this.result = "Phone number is not valid. Access denied.";
      // }

      // Remove non-numeric characters from the input
      this.phoneNumber = this.phoneNumber.replace(/\D/g, "");
    },

    phoneNumberCallBack(e) {
      e.message =
        "Phone Number '<b>" + e.proposedValue + "</b>' is already registered.";

      const me = this;

      me.phoneNumber = "";

      return this.isValidEntity(
        "dbo.WebAccount",
        "phoneNumber",
        e.proposedValue,
        false
      ).then((result) => {
        return !result;
      });
    },

    onSubmit() {
      const me = this;

      if (me.surveyorTypeId == 1 || me.surveyorTypeId == 3) {
        me.setRequiredMode("ptrNumber", "ptrIssueDate", "ptrExpiryDate");
      } else {
        me.setOptionalMode("ptrNumber", "ptrIssueDate", "ptrExpiryDate");
      }

      if (!me.isValid(me.$options.name)) {
        me.advice.fault("Fill in the required fields (marked in red).", {
          duration: 5,
        });
        return;
      }

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        me.advice.fault(
          "The password does not meet the password policy requirements. Check the minimum password length.",
          { duration: 5 }
        );
        return;
      }

      if (!me.OTP) {
        me.advice.fault("OTP is required.", { duration: 5 });
        return;
      }

      if (me.OTP.toString() !== me.requestedOTP.toString()) {
        me.advice.fault("incorrect OTP.", { duration: 5 });
        return;
      }

      if (!me.intervalId) {
        me.stopCountDown();
      }

      if (me.accountTypeId > 4 || me.accountTypeId < 3) {
        me.dialog.fault("Tampered account rejected.").then(() => {
          me.goHome();
        });
        return;
      }

      if (me.password !== me.confirmPassword) {
        me.advice.fault("Cannot confirm password.", { duration: 5 });
        return;
      }

      let wait = me.wait();

      me.createAccount().then(
        (success) => {
          if (success) {
            let message = "Sign-up completed.";

            me.stopWait(wait);
            me.dialog.success(message).then(() => {
              me.goLogin();
            });
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    // helpers

    goLogin() {
      let route = {
        name: "logon",
      };
      this.go(route);
    },

    setupRecaptcha() {
      const me = this;

      window.recaptchaCallback = function(response) {
        const wait = me.wait();
        verifyRecaptcha(response).then(
          (info) => {
            me.stopWait(wait);
            me.recaptcha.isHuman = info.success;
          },
          (fault) => {
            me.stopWait(wait);
            me.showFault(fault);
          }
        );
      };

      window.recaptchaExpiredCallback = function() {
        me.recaptcha.isHuman = false;
      };

      me.recaptcha.siteKey = appConfig.recaptcha.siteKey;
    },

    getAccountReferences() {
      return get("api/app-references");
    },
    //123
    // validateAge() {
    //   // Calculate age based on birthdate
    //   const today = new Date();
    //   const birthDate = new Date(this.birthdate);
    //   const age = today.getFullYear() - birthDate.getFullYear();

    //   // Check if user is under 18
    //   if (age < 18) {
    //     this.isUnderAge = true;
    //     this.registrationSuccess = false;
    //   } else {
    //     this.isUnderAge = false;
    //     this.registrationSuccess = true;
    //     e.preventDefault();
    //   }
    // },
  },

  mounted() {
    const me = this;

    if (me.sym.userInfo.userId > 0) {
      me.goHome();
      return;
    }

    // me.createPDF();

    me.getAccountReferences().then((data) => {
      if (data) {
        me.surveyorType = data.surveyorType;
        me.surveyorType.unshift({
          surveyorTypeId: "",
          surveyorTypeName: "--- Select Type ---",
        });
      }
    });

    me.setupRecaptcha();

    me.syncValues(me.params, me.query);
    me.replaceUrl();

    me.setRequiredMode(
      "logonId",
      "password",
      "confirmPassword",
      "lastName",
      "firstName",
      "shortName",
      "birthDate",
      "phoneNumber",
      "address",
      "OTP"
    );

    if (me.isEngineer) {
      me.setRequiredMode(
        "prcNumber",
        "prcIssueDate",
        "prcExpiryDate",
        // 'ptrNumber',
        // 'ptrIssueDate',
        // 'ptrExpiryDate',
        "phoneNumber",
        "OTP",
        "surveyorTypeId"
      );
    }

    me.$nextTick(() => {
      setTimeout(() => {
        let fm = me.meta["password"];
        if (fm) {
          fm.minLength = 8;
        }

        if (me.accountTypeId === 3 && !appConfig.canRegisterSurveyor) {
          me.dialog
            .fault("Geodetic Engineer sign-up is not available at this time.")
            .then(() => {
              me.goHome();
            });
        }

        if (me.accountTypeId === 4 && !appConfig.canRegisterClient) {
          me.dialog
            .fault("Client registration is not available at this time.")
            .then(() => {
              me.goHome();
            });
        }

        me.setFocus("logonId");
      }, 500);
    });
  },
};
</script>

<style scoped>
.reg-container {
  display: flex;
}

.reg-container >>> .form-control {
  margin-bottom: 2px;
}

.reg-container >>> .input-tag {
  padding-bottom: 2px;
  margin-left: 2px;
}

.reg-form {
  width: 40%;
  padding: 1rem 2rem;
}

.recaptcha-container {
  transform-origin: 0 0;
}

.equal-width {
  display: flex;
}

.equal-width > * {
  flex: 1;
}

.equal-width > :not(:last-child) {
  margin-right: 0.5rem;
}

.equal-width :last-child {
  margin-right: 0;
}

.notice {
  padding: 2rem 4rem;
}
.MobilePhone {
  height: 37px;
}
.PhoneContainer {
  margin-top: 8px;
}
.PhoneHeader {
  margin-left: 4px;
}
.showEyeIcon {
  float: right;
  margin-top: -32px;
  margin-right: 20px;
  cursor: pointer;
  /* margin-left: 20px;
  margin-bottom: 60px; */
}
.ShowConfirmEyeIcon {
  float: right;
  margin-top: -30px;
  margin-right: 20px;
  offset: 10px;
  cursor: pointer;
}
.ShowPassword {
  height: 45px;
}
.ConfirmPassword {
  /* height: 45px;
  margin-bottom: 10px; */
}

@media (max-width: 1024px) {
  .reg-form {
    width: 60%;
  }
}

@media (max-width: 800px) {
  .reg-form {
    width: 70%;
  }

  .notice {
    padding: 2rem 3rem;
  }
}

@media (max-width: 640px) {
  .reg-form {
    width: 80%;
    padding: 1.25rem;
  }

  .notice {
    padding: 2rem 2rem;
  }
}

@media (max-width: 560px) {
  .notice {
    padding: 1rem 1rem;
  }
}

@media (max-width: 480px) {
  .reg-form {
    width: 90%;
  }
  .reg-button {
    margin-top: 0.5rem !important;
  }
}

@media (max-width: 384px) {
  .reg-form {
    padding: 0.75rem;
  }
  .recaptcha-container {
    transform: scale(0.9);
  }
}

@media (max-width: 320px) {
  .reg-form {
    width: 96%;
    padding: 0.5rem;
  }
  .recaptcha-container {
    transform: scale(0.9);
  }
}

/* Basic Config --------- */

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: "Open Sans", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff6b6b;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h2 {
  text-align: center;
  color: #fff;
  font-weight: 400;
}

ul {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

li {
  margin-bottom: 8px;
  color: #525f7f;
  position: relative;
}

li:before {
  content: "";
  width: 0%;
  height: 2px;
  background: #2ecc71;
  position: absolute;
  left: 0;
  top: 50%;
  display: block;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

#app {
  width: 400px;
}

/* Password Input --------- */

.input_container {
  position: relative;
  padding: 30px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  border-radius: 6px;
  background: #fff;
}

input[type="password"] {
  line-height: 1.5;
  display: block;
  color: rgba(136, 152, 170, 1);
  font-weight: 300;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: 0.625rem 0.75rem;
  border-radius: 0.25rem;
  background-color: #fff;
  transition: border-color 0.4s ease;
  border: 1px solid #cad1d7;
  outline: 0;
}

input[type="password"]:focus {
  border-color: rgba(50, 151, 211, 0.45);
}

/* Checkmark & Strikethrough --------- */

.is_valid {
  color: rgba(136, 152, 170, 0.8);
}
.is_valid:before {
  width: 100%;
}

.checkmark_container {
  border-radius: 50%;
  position: absolute;
  top: -15px;
  right: -15px;
  background: #2ecc71;
  width: 50px;
  height: 50px;
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease;
}

.show_checkmark {
  visibility: visible;
  opacity: 1;
}

.checkmark {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: white;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
}

.checked {
  animation: draw 0.5s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
